import React, { useId, useRef, useState, useEffect } from 'react';
import { usePropState, useDebouncedProp } from '@anton.bobrov/react-hooks';
import { vevet } from '@anton.bobrov/vevet-init';
import { ExpandContent } from '@anton.bobrov/react-components';
import cx from 'classnames';
import { Thumb } from '../RenderCollapsedMenu/Thumb/index.js';
import { LinkCollectionLines } from '../Lines/index.js';
import { SimpleLink } from '../SimpleLink/index.js';
import styles from './index.module.scss.js';

const LinkCollectionV2 = ({
  className,
  style,
  isExpanded: isExpandedProp,
  name,
  links,
  small
}) => {
  const id = useId();
  const listRef = useRef(null);
  const [isExpanded, setIsExpanded] = usePropState(isExpandedProp);
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const isShown = useDebouncedProp(!!isExpanded, 200);
  const shouldShowLinks = useDebouncedProp(isExpanded, isExpanded ? 1 : 750);
  useEffect(() => {
    setIsExpanded(true);
  }, []);
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style, "data-small": small }, !small && /* @__PURE__ */ React.createElement("span", { className: styles.title }, name), /* @__PURE__ */ React.createElement(
    ExpandContent,
    {
      className: styles.expanded,
      isActive: isExpanded,
      duration: 750,
      isContentRendered: false,
      hasAlpha: false
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.list,
        ref: listRef,
        id,
        "aria-hidden": !isExpanded,
        "data-list": true,
        onMouseLeave: () => !vevet.isMobile && setHoveredIndex(-1)
      },
      !small && /* @__PURE__ */ React.createElement(
        LinkCollectionLines,
        {
          className: styles.lines,
          listRef,
          activeIndex: hoveredIndex,
          isShown
        }
      ),
      links.map((link, index) => /* @__PURE__ */ React.createElement(
        "div",
        {
          key: link.name,
          className: "js-item",
          onMouseEnter: () => !vevet.isMobile && setHoveredIndex(index)
        },
        small ? /* @__PURE__ */ React.createElement(Thumb, { kind: "pure", ...link, key: link.href }) : /* @__PURE__ */ React.createElement(
          SimpleLink,
          {
            ...link,
            className: cx(styles.link, {
              [styles.show]: !!shouldShowLinks
            }),
            style: {
              "--delay": `${index * 50}ms`
            }
          }
        )
      ))
    )
  ));
};

export { LinkCollectionV2 };
//# sourceMappingURL=index.js.map
